import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Clock } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  return (
    <Layout hideFooter>
      <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center p-4">
        <div className="text-center max-w-lg">
          {/* Animated 404 */}
          <div className="relative mb-8">
            <h1 className="text-[150px] md:text-[200px] font-bold text-muted/30 leading-none select-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-float">
                <Clock className="w-24 h-24 text-primary" />
              </div>
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Oups ! Le temps s'est arrêté ici
          </h2>
          
          <p className="text-muted-foreground text-lg mb-8">
            La page que vous cherchez n'existe pas ou à été déplacée. 
            Mais ne vous inquiétez pas, vous pouvez toujours retourner échanger du temps !
          </p>

          {/* Fun facts */}
          <div className="bg-muted/50 rounded-2xl p-6 mb-8 text-left">
            <p className="text-sm text-muted-foreground mb-2">💡 Le saviez-vous ?</p>
            <p className="text-sm">
              Pendant que vous étiez perdu, <span className="font-semibold text-primary">3 nouveaux échanges</span> ont 
              eu lieu dans la communauté Oknî !
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="btn-primary w-full sm:w-auto">
                <Home className="w-4 h-4 mr-2" />
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/services">
              <Button variant="outline" className="rounded-full w-full sm:w-auto">
                <Search className="w-4 h-4 mr-2" />
                Explorer les services
              </Button>
            </Link>
          </div>

          {/* Easter egg */}
          <p className="text-xs text-muted-foreground mt-12">
            🕐 Conseil : Le temps perdu ne se rattrape jamais, mais les crédits Oknî, oui !
          </p>
        </div>
      </div>
    </Layout>
  );
}
